module.exports = __webpack_public_path__ + "img/naed-logo.040d2baa.png";